(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5001],{

/***/ 86497:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-pages-v2/[...slug]",
      function () {
        return __webpack_require__(15398);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-scroll-parallax/dist/index.mjs + 1 modules
var dist = __webpack_require__(60222);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.tsx + 3 modules
var HeroV2 = __webpack_require__(32296);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2WithMarkers.tsx + 2 modules
var HeroV2WithMarkers = __webpack_require__(50069);
// EXTERNAL MODULE: ./src/cms/entries/dynamicEntry.ts
var dynamicEntry = __webpack_require__(85733);
;// CONCATENATED MODULE: ./src/cms/entries/homePageV2.ts
// Static imports for hero and above-the-fold components (critical for LCP)



// Dynamic imports for below-the-fold components only
var CarouselCards = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6737).then(__webpack_require__.bind(__webpack_require__, 66737));
});
var ContactSection = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7712).then(__webpack_require__.bind(__webpack_require__, 7712));
});
var LWCTextSection = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 1344).then(__webpack_require__.bind(__webpack_require__, 11344));
});
var MapBackgroundHero = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 5715).then(__webpack_require__.bind(__webpack_require__, 55715));
});
var LWCHeroCard = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9918).then(__webpack_require__.bind(__webpack_require__, 29918));
});
var LWCImageCard = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 536).then(__webpack_require__.bind(__webpack_require__, 10536));
});
var Spacer = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 5739).then(__webpack_require__.bind(__webpack_require__, 95739));
});
var StandaloneText = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51831));
});
var FCHero = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9925).then(__webpack_require__.bind(__webpack_require__, 29925));
});
var FCTrustBanner = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6193).then(__webpack_require__.bind(__webpack_require__, 6193));
});
var FCValueTracker = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9046).then(__webpack_require__.bind(__webpack_require__, 39046));
});
var FCThreeSteps = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2141).then(__webpack_require__.bind(__webpack_require__, 72141));
});
var FCProductOptions = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 5410).then(__webpack_require__.bind(__webpack_require__, 85410));
});
var FCTestimonialCarousel = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2815).then(__webpack_require__.bind(__webpack_require__, 62815));
});
var FCMap = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 1792).then(__webpack_require__.bind(__webpack_require__, 61792));
});
var FCMissionStatement = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 4543).then(__webpack_require__.bind(__webpack_require__, 84543));
});
var FCContactUs = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2483).then(__webpack_require__.bind(__webpack_require__, 72483));
});
var TextBanner = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7924).then(__webpack_require__.bind(__webpack_require__, 77924));
});
var homePageV2EntryLookup = {
    // only including blocks used in https://app.contentful.com/spaces/bjlp9d7o6h1o/entries/3jH3XGe228kfdp8fBGddyW?focusedField=slug
    // for performance
    block: {
        lpComponentMapBackgroundHero: MapBackgroundHero,
        lpComponentCarouselCards: CarouselCards,
        lpComponentContactSection: ContactSection,
        lpComponentLwcTextSection: LWCTextSection,
        lpComponentLwcHeroCard: LWCHeroCard,
        lpComponentLwcImageCard: LWCImageCard,
        lpComponentHeroV2: HeroV2/* default */.Z,
        lpComponentHeroV2WithMarkers: HeroV2WithMarkers/* default */.Z,
        lpComponentSpacer: Spacer,
        lpComponentStandaloneText: StandaloneText,
        fcHero: FCHero,
        fcTrustBanner: FCTrustBanner,
        fcValueTracker: FCValueTracker,
        fcThreeSteps: FCThreeSteps,
        fcProductOptions: FCProductOptions,
        fcTestimonialCarousel: FCTestimonialCarousel,
        fcMap: FCMap,
        fcMissionStatement: FCMissionStatement,
        fcContactUs: FCContactUs,
        lpComponentTextBanner: TextBanner
    },
    inline: {}
};
/* harmony default export */ var homePageV2 = (homePageV2EntryLookup);

// EXTERNAL MODULE: ./src/cms/entries/landingPageV2.ts + 1 modules
var landingPageV2 = __webpack_require__(43862);
// EXTERNAL MODULE: ./src/cms/renderer/index.tsx
var renderer = __webpack_require__(32239);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 57 modules
var observability = __webpack_require__(49048);
// EXTERNAL MODULE: ./src/helpers/ReturnExperienceContext.tsx
var ReturnExperienceContext = __webpack_require__(78223);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./src/helpers/StickyCTABarContext.tsx



var StickyCTABarContext = /*#__PURE__*/ react.createContext({
    visible: false,
    setVisible: function() {
        return null;
    }
});
var StickyCTABarContextProvider = function(param) {
    var children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), visible = ref[0], setVisible = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTABarContext.Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        },
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/shared/LandingPageV2Layout.tsx + 1 modules
var LandingPageV2Layout = __webpack_require__(39275);
;// CONCATENATED MODULE: ./src/pages/landing-pages-v2/[...slug].tsx













var LandingPageWithContext = function(props) {
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var router = (0,next_router.useRouter)();
    var nextJsPath = router.asPath.split("?")[0];
    var isHomePage = nextJsPath === "/"; // || true to debug HP perf
    var cmsEntryLookup = isHomePage ? homePageV2 : landingPageV2/* default */.Z;
    (0,react.useEffect)(function() {
        // only measuring homepage load-time performance
        if (false) {}
        // only measuring if the slug contains 'homepage'
        // we have a few variants of the homepage like /homepage-syw-v2-home-guide
        if (window.location.pathname !== "/") return;
        trackJourneyEvent("platform", "pageLoadedEvent", {
            // Next.js route, which is not necessarily the client-side URL
            routerPath: nextJsPath,
            loadTimeMs: Math.round(performance.now())
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* ParallaxProvider */.Xu, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnExperienceContext/* ReturnExperienceContextProvider */.Q, {
            showReturnExperience: props.fields.showReturnExperienceBanner,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTABarContextProvider, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPageV2Layout["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                        body: props.fields.body,
                        idToLoaderData: props.idToLoaderData,
                        entryLookup: cmsEntryLookup
                    })
                }))
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (LandingPageWithContext);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6852,7081,5527,6523,4490,2864,2345,1284,188,8111,6696,5675,7949,3038,297,4991,2681,9872,3203,9275,9774,2888,179], function() { return __webpack_exec__(86497); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);